namespace Dashboard {

    export class BookingActionLink {
        private desktopUrl: string = 'desktop-url/{{BookingRef}}/{{BookingId}}/{{LeadPassengerLastName}}';
        private actionLinks: any = {
            'VIEWBOOKINGDETAILS': 'dashboard/booking-details/{{::BookingId}}',
            'CHANGECONTACTDETAILS': 'dashboard/contact-detail/{{::BookingId}}',
            'CANCELBOOKINGS': TRPCONFIG.Domain.CreateCSRToCancelBooking ?
                'dashboard/create-csr/{{BookingId}}?id=3': this.desktopUrl + '/cancel',
            'CSR': TRPCONFIG.Domain.DisableFAQs ?
                'dashboard/create-csr/{{BookingId}}': 'dashboard/csr/{{BookingId}}',
            'MANAGEPASSENGERDETAILS': this.desktopUrl + '/api',
            'PRINTVOUCHER': 'document/receipt/{{::BookingId}}',
            'PRINTRECEIPT': 'document/receipt/{{::BookingId}}',
            'PAYBALANCE': TRPCONFIG.Domain.PaybalanceV2Enabled ?
                'dashboard/pay-balance/{{::BookingId}}' : this.desktopUrl + '/payment',
            'ONLINECHECKIN': 'dashboard/online-checkin/{{BookingId}}',
            'VOUCHERACTIONS': 'dashboard/resend-voucher/{{BookingId}}',
            'AMENDBOOKING': TRPCONFIG.Domain.CreateCSRToAmendBooking ?
                'dashboard/create-csr/{{BookingId}}?id=159' :
                TRPCONFIG.Domain.EnableAmendBookingV2 ?
                'dashboard/amend-booking/{{BookingRef}}/{{BookingId}}/{{LeadPassengerLastName}}/start' :
                this.desktopUrl + '/amend',
            'ENTERAPI': TRPCONFIG.Domain.DashboardAddAPIEnabled ?
                'dashboard/add-api/{{::BookingId}}' : this.desktopUrl + '/api',
            'ENTERREVIEW': 'review-hotel/{{BookingId}}',
            'ADDBAGGAGE': 'dashboard/add-baggage/{{::BookingId }}',
            'ADDSEATS': 'dashboard/seat-selection/{{::BookingId }}',
            'DERWENTLINK': TRPCONFIG.Domain.DerwentUrl + 'Booking/boBookingDetails.aspx?BookingId={{BookingId}}',
            'PRINTINVOICE': 'document/invoice/{{::BookingId}}'
        };
        public get() {
            return angular.copy(this.actionLinks);
        }
    }

    angular
        .module('dashboard')
        .service('bookingActionLink', BookingActionLink);

}
